import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { FiSearch, FiBell, FiUser, FiLogOut, FiSettings, FiMenu, FiEye } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import './Header.css';
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;


const Header = () => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [pendingUsers, setPendingUsers] = useState([]);

  // Fetch pending users from backend
  useEffect(() => {
    const fetchPendingUsers = async () => {
      try {
        const res = await fetch(`${url}/api/members/pending`);
        const data = await res.json();
        // console.log('Pending users API response:', data);

        // Make sure we always have an array
        if (Array.isArray(data)) {
          setPendingUsers(data);
        } else if (Array.isArray(data.pendingUsers)) {
          setPendingUsers(data.pendingUsers);
        } else {
          setPendingUsers([]);
        }
      } catch (err) {
        console.error('Failed to fetch pending users:', err);
        setPendingUsers([]);
      }
    };

    fetchPendingUsers();

    // Refresh every 30 seconds
    const interval = setInterval(fetchPendingUsers, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    logout();
    setShowDropdown(false);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log('Searching for:', searchQuery);
    setSearchQuery('');
  };

  // Admin action handlers
  const handleApprove = async (userId, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (window.confirm('Are you sure you want to approve this member?')) {
      await fetch(`${url}/api/members/${userId}/action`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'approve' }),
      });
      setPendingUsers((prev) => prev.filter((u) => u._id !== userId));
    }
  };

  const handleReject = async (userId, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const reason = prompt('Please provide a reason for rejection:');
    if (!reason) return;
    
    await fetch(`${url}/api/members/${userId}/action`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'reject', note: reason }),
    });
    setPendingUsers((prev) => prev.filter((u) => u._id !== userId));
  };

  const handleNeedsChanges = async (userId, e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const note = prompt('Enter what needs to be changed:');
    if (!note) return;
    
    await fetch(`${url}/api/members/${userId}/action`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'needs_changes', note }),
    });
    setPendingUsers((prev) => prev.filter((u) => u._id !== userId));
  };

  return (
    <header className="app-header">
      {/* Mobile menu button */}
      <button className="mobile-menu-btn">
        <FiMenu />
      </button>

      {/* Search Bar */}
      <div className="search-container">
        <form onSubmit={handleSearch} className="search-form">
          <div className="search-input-group">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>
        </form>
      </div>

      {/* Header Actions */}
      <div className="header-actions">
        {/* Notifications */}
        <button className="notification-btn" onClick={() => setShowDropdown(!showDropdown)}>
          <FiBell />
          {pendingUsers.length > 0 && (
            <span className="notification-badge">{pendingUsers.length}</span>
          )}
        </button>

        {/* User Profile */}
        <div className="user-profile-container">
          <button
            className="user-profile-btn"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="user-avatar">
              {user?.avatar ? <img src={user.avatar} alt={user?.name} /> : <FiUser />}
            </div>
            <div className="user-info">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">{user?.role}</span>
            </div>
          </button>

          {/* Dropdown Menu */}
          {showDropdown && (
            <div className="dropdown-menu">
              {/* Pending Users Section */}
              <div className="dropdown-header">
                <h4>Pending Registrations</h4>
              </div>
              <div className="dropdown-divider"></div>

              {Array.isArray(pendingUsers) && pendingUsers.length > 0 ? (
                pendingUsers.map((u) => (
                  <div key={u._id} className="dropdown-item pending-user-item">
                    <Link 
                      to={`/members/view/${u._id}`} 
                      className="pending-user-link"
                      onClick={() => setShowDropdown(false)}
                    >
                      <span>{u.fname} {u.lname}</span>
                      <FiEye className="view-icon" title="View Details" />
                    </Link>
                    {/* <div className="pending-user-actions">
                      <button 
                        className="approve-btn"
                        onClick={(e) => handleApprove(u._id, e)}
                        title="Approve"
                      >
                        Approve
                      </button>
                      <button 
                        className="reject-btn"
                        onClick={(e) => handleReject(u._id, e)}
                        title="Reject"
                      >
                        Reject
                      </button>
                      <button 
                        className="needs-changes-btn"
                        onClick={(e) => handleNeedsChanges(u._id, e)}
                        title="Request Changes"
                      >
                        Change
                      </button>
                    </div> */}
                  </div>
                ))
              ) : (
                <div className="dropdown-item">No pending users</div>
              )}

              <div className="dropdown-divider"></div>

              {/* User Profile Options */}
              <div className="dropdown-header">
                <div className="dropdown-avatar">
                  {user?.avatar ? <img src={user.avatar} alt={user?.name} /> : <FiUser />}
                </div>
                <div className="dropdown-user-info">
                  <span className="dropdown-name">{user?.name}</span>
                  <span className="dropdown-email">{user?.email}</span>
                </div>
              </div>

              {/* <div className="dropdown-divider"></div>
              <button className="dropdown-item">
                <FiUser className="dropdown-icon" />
                <span>Profile</span>
              </button> */}
              <div className="dropdown-divider"></div>
              <button className="dropdown-item logout-item" onClick={handleLogout}>
                <FiLogOut className="dropdown-icon" />
                <span>Logout</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Overlay for closing dropdown */}
      {showDropdown && (
        <div className="dropdown-overlay" onClick={() => setShowDropdown(false)} />
      )}
    </header>
  );
};

export default Header;